import React, { lazy, Suspense } from 'react';

const LazyThongTinTaiKhoan = lazy(() => import('./ThongTinTaiKhoan'));

const ThongTinTaiKhoan = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyThongTinTaiKhoan {...props} />
  </Suspense>
);

export default ThongTinTaiKhoan;
